import React from 'react';
import styles from './MultiSelectTopics.module.css';
import { HiXCircle, HiTag } from 'react-icons/hi2';
import { useTranslation } from 'react-i18next';
import { useFirestoreDoc } from '../../hooks/useFirestoreDoc';
import { useNotifications } from "../../utils/NotificationContext/NotificationContext";
import Button from '../ui/Button';

const allTopics = [
  "Politics", "Philosophy", "Economics", "Science",
  "Technology", "Education", "Environment", "Law",
  "Religion", "Social Justice", "History", "Healthcare"
];

export default function MultiSelectTopics({ value = [], onChange, disabled }) {
  const { t } = useTranslation();
  const { notify } = useNotifications();
  
  const handleAdd = (topic) => {
    if (value.includes(topic)) return;
    onChange([...value, topic]);
  };

  const handleRemove = (topic) => {
    onChange(value.filter(t => t !== topic));
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.selected}>
        {value.length === 0 && <span className={styles.placeholder}>{t('profile.topicsPlaceholder')}</span>}
        {value.map(topic => (
          <span key={topic} className={styles.tag}>
            {topic}
            {!disabled && <HiXCircle className={styles.removeIcon} onClick={() => handleRemove(topic)} />}
          </span>
        ))}
      </div>

      {!disabled && (
        <div className={styles.options}>
          {allTopics.map(topic => (
            <Button
              key={topic}
              className={`${styles.optionBtn} ${value.includes(topic) ? styles.selectedBtn : ''}`}
              onClick={() => handleAdd(topic)}
            >
              <HiTag className={styles.optionIcon} /> {topic}
            </Button>
          ))}
        </div>
      )}
    </div>
  );
}
